import { loadBenefitsFormDocument, loadBenefitsFormDocumentInfo, loadBenefitsFormDocumentInfoSuccess, signBenefitsFormDocument, signBenefitsFormDocumentSuccess } from './../../../../core/store/benefits/benefits.actions';
import { UserProfileModel } from 'src/app/models/userProfileModel';
import { loadProfile } from './../../../../core/store/profile/profile.actions';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from './../../../../shared/services/alert.service';
import { UserModel } from 'src/app/models/userModel';
import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { Actions, ofType } from '@ngrx/effects';
import * as moment from 'moment';
import { SignDocComponentBase } from '../../../abstract/signDocBase.component';
import { tap } from 'rxjs';
import { downloadFile, deepClone, clearArray } from 'src/app/helpers/utils';
import { BenefitPlanFormDocumentsEnrollmentModel } from 'src/app/models/benefitsModels';
import { getBenefitsFormDocumentsList } from 'src/app/core/store/benefits/benefits.actions';

@Component({
    selector: 'app-sign-enrollmentformdoc',
    templateUrl: './sign-enrollmentformdoc.component.html',
    styleUrls: ['./sign-enrollmentformdoc.component.scss'],
    standalone: false
})
export class SignEnrollmentFormDocComponent extends SignDocComponentBase implements OnInit, AfterViewInit {

  @Input() benefitPlanFormDocumentsEnrollmentID: string;
  @Input() doNotNavigate: boolean;
  loadingSign = false;
  loadingDoc = true;
  user: UserModel;
  @Input() profile: UserProfileModel;
  docsList: BenefitPlanFormDocumentsEnrollmentModel[];
  docInfo: BenefitPlanFormDocumentsEnrollmentModel;

  constructor(
    private store: Store<State>,
    private actions$: Actions,
    private alert: AlertService,
    private router: Router,
    private route: ActivatedRoute) {
    super(store);
  }

  ngOnInit() {
    if (this.router.url.indexOf('benefits-management/') >= 0) {
      this.isSigningAsHRManager = true;
    }
    this.store.dispatch(loadProfile());
    this.store.dispatch(getBenefitsFormDocumentsList({ userId: null }));
    if (this.benefitPlanFormDocumentsEnrollmentID) {
      this.optionalFields.length = 0;
      this.store.dispatch(loadBenefitsFormDocument({ benefitPlanFormDocumentsEnrollmentID: parseInt(this.benefitPlanFormDocumentsEnrollmentID, 10) }));
      this.store.dispatch(loadBenefitsFormDocumentInfo({ benefitPlanFormDocumentsEnrollmentID: parseInt(this.benefitPlanFormDocumentsEnrollmentID, 10) }));
    } else {
      this.route.params.subscribe(params => {
        if (params.benefitPlanFormDocumentsEnrollmentID) {
          this.benefitPlanFormDocumentsEnrollmentID = params.benefitPlanFormDocumentsEnrollmentID;
          this.optionalFields.length = 0;
          this.store.dispatch(loadBenefitsFormDocument({ benefitPlanFormDocumentsEnrollmentID: parseInt(this.benefitPlanFormDocumentsEnrollmentID, 10) }));
          this.store.dispatch(loadBenefitsFormDocumentInfo({ benefitPlanFormDocumentsEnrollmentID: parseInt(this.benefitPlanFormDocumentsEnrollmentID, 10) }));
        }
      });
    }


    this.subs.push(
      this.store.select(s => s.profileState.profile).subscribe(p => {
        if (p) {
          this.user = p.user;
        }
      }),
      this.store.select(s => s.benefitsState.docInfoBenefit).subscribe(docInfo => {
        if (docInfo) {
          this.docInfo = docInfo;
          // Make Signature#HRUser#2 optional if the user did not filled RehireDate
          if (this.docInfo.benefitPlanFormDocument.fileName.indexOf('i9Form') >= 0) {
            if (this.profile && !this.profile.employee.i9RehireDate) {
              if (this.optionalFields.indexOf('Signature#HRUser#2') < 0) {
                this.optionalFields.push('Signature#HRUser#2');
              }
            }
          }
        }
      }),
      this.store.select(s => s.benefitsState.docArrayBufferBenefit).subscribe(docArrayBuffer => {
        if (docArrayBuffer) {
          if (this.intervalFormattingSignature) {
            clearInterval(this.intervalFormattingSignature);
          }
          clearArray(this.signedFields);
          this.url =
            URL.createObjectURL(new Blob([docArrayBuffer], {
              type: 'application/pdf'
            })) + '&avoidcache=' + (new Date()).getTime();

          this.afterPdfViewerInit();
        }
      }),
      this.store.select(s => s.benefitsState.loadingDocBenefit).subscribe(loadingDoc => {
        this.loadingDoc = loadingDoc;
      }),
      this.store.select(s => s.benefitsState.loadingSignBenefit).subscribe(loadingSign => {
        this.loadingSign = loadingSign;
      }),
      this.store.select(s => s.benefitsState.docsListBenefit).subscribe(docsList => {
        this.docsList = docsList;
      }),
      this.actions$.pipe(
        ofType(signBenefitsFormDocumentSuccess),
        tap(action => {
          if (!this.doNotNavigate) {
            this.alert.confirm('Documentation signed succesfully',
              'Documentation signed succesfully. Do you want to download the signed file now?')
              .subscribe(
                answer => {
                  if (answer) {
                    downloadFile(action.docSigned, 'document.pdf');
                  }

                  this.router.navigate(['../../list'], { relativeTo: this.route });

                }, error => {
                  this.router.navigate([`../../list`], { relativeTo: this.route });
                }
              );
          }
        })
      ).subscribe()
    );
  }

  get loggedUserName() {
    return !this.user ? '' : (this.user.firstName + ' ' + this.user.lastName);
  }

  get loggedUserEmail() {
    return !this.user ? '' : this.user.email;
  }

  sign() {
    if (!this.finishSignDisabled) {
      this.store.dispatch(
        signBenefitsFormDocument({ benefitPlanFormDocumentsEnrollmentID: parseInt(this.benefitPlanFormDocumentsEnrollmentID, 10), signedFields: deepClone(this.signedFields) }));
    }
  }

}
